module.exports = __webpack_public_path__ + "static/024-072a1083416feaeab4904e60292e7136.png";